
















































































































import Vue from 'vue'
import moment from 'moment'
// @ts-ignore
import { AgGridVue } from 'ag-grid-vue'
import { GridOptions } from 'ag-grid-community'
import {
  GET_SECURITY_DATA,
  GET_SELECTED_UI_LANGUAGE,
  PLANNING_ASSISTANT_GET_END_DATE, PLANNING_ASSISTANT_GET_IS_EDITTING_SERIE,
  PLANNING_ASSISTANT_GET_PERIODICITY, PLANNING_ASSISTANT_GET_PERIODICITY_PLANNED_EMPLOYEE_LIST,
  PLANNING_ASSISTANT_GET_PLANNED_EMPLOYEE_LIST,
  PLANNING_ASSISTANT_GET_SHIFT_AVAILABILITY,
  PLANNING_ASSISTANT_GET_START_DATE
} from '@/store/getter-types'
import { PlanningAssistantPeriodicityPayload } from '@/types/payload'
import { PlannedEmployee } from '@/model/planning/PlannedEmployee'
import { PLANNING_ASSISTANT_SET_SHIFT_AVAILABILITY } from '@/store/action-types'
import { ShiftAvailability } from '@/types/enums'
import { EditShiftPlan } from '@/model/planning/EditShiftPlan'
import { PeriodicityPlannedEmployee } from '@/types'
import { SecurityData } from '@/model/SecurityData'
import { Address } from '@/model/planning/Address'
import { PlanningLookupProject } from '@/model/planning/PlanningLookupProject'

interface ComponentData {
  gridOptions: GridOptions,
  shiftAvailabilityState: boolean
  overlayNoRowsTemplate: string
  panel: number[]
  showAddressSelect: boolean
  showProjectSelect: boolean
}

export default Vue.extend({
  name: 'ShiftEditorFinish',

  components: {
    AgGridVue
  },

  props: {
    step: String,
    editShift: Object as () => EditShiftPlan | undefined,
    selectedAddress: Object as () => Address | undefined,
    selectedProject: Object as () => PlanningLookupProject | null,
  },

  data (): ComponentData {
    return {
      gridOptions: {
        columnDefs: [
          { headerName: this.$t('planningPage.name').toString(), field: 'name' },
          {
            headerName: this.$t('planningPage.start').toString() + '/' + this.$t('planningPage.end').toString(),
            field: 'startEnd'
          },
          { headerName: this.$t('planningPage.work').toString(), field: 'taskName' },
          { headerName: this.$t('planningPage.competence').toString(), field: 'competenceName' },
          { headerName: this.$t('planningPage.education').toString(), field: 'educationName' },
          { headerName: this.$t('planningPage.note').toString(), field: 'note' }
        ]
      },

      shiftAvailabilityState: false,
      overlayNoRowsTemplate: '<span>' + this.$t('errors.noRowsToShow') + '</span>',
      panel: [0],
      showAddressSelect: false,
      showProjectSelect: false
    }
  },

  watch: {
    step (newVal: string): void {
      if(newVal && newVal === '7') {
        setTimeout(() => {
          const saveButton: any = this.$refs['saveButton']
          if (saveButton) {
            saveButton.$el.focus()
          }
        }, 300)
      }
    },
  },

  computed: {
    date (): string {
      const dateStart: Date = this.$store.getters[PLANNING_ASSISTANT_GET_START_DATE]
      const dateEnd: Date = this.$store.getters[PLANNING_ASSISTANT_GET_END_DATE]

      const dateStartMoment = moment(dateStart)

      let displayDate: string

      if (dateStartMoment.isSame(dateEnd, 'date')) {
        displayDate = dateStartMoment.format('D.M.YYYY')
      } else {
        const dateEndMoment = moment(dateEnd)

        displayDate = `${dateStartMoment.format('D.M.YYYY')} - ${dateEndMoment.format('D.M.YYYY')}`
      }

      return displayDate
    },

    startEndTime (): string {
      const dateStart = moment(this.$store.getters[PLANNING_ASSISTANT_GET_START_DATE])
      const dateEnd = moment(this.$store.getters[PLANNING_ASSISTANT_GET_END_DATE])

      return `${dateStart.format('HH:mm')} - ${dateEnd.format('HH:mm')}`
    },

    periodicity (): string {
      const periodicityData: PlanningAssistantPeriodicityPayload = this.$store.getters[PLANNING_ASSISTANT_GET_PERIODICITY]

      let periodicityString: string = ''

      if (periodicityData.isUnique) {
        periodicityString = this.$t('planningPage.unique').toString()

      } else {
        const days: string[] = periodicityData.weekDayList.map((dayNumber: number): string => {
          return moment().day(dayNumber).locale(this.$store.state.selectedUiLanguage.code).format('dd')
        })

        let periodicityNotUnique: Array<string> = []

        if (days.length) {
          periodicityNotUnique.push(days.join(', '))
        }

        periodicityNotUnique.push(`${this.$t('planningPage.everyWeek').toString()} : ${periodicityData.repeatEveryNthWeek}`)

        if (periodicityData.expireAfterRepetitions > 0) {
          periodicityNotUnique.push(`${this.$t('planningPage.endAfterExecutions').toString()} : ${periodicityData.expireAfterRepetitions}`)
        }

        if (periodicityData.expireAfterDate) {
          const date = moment(periodicityData.expireAfterDate).format('DD.MM.YYYY')

          periodicityNotUnique.push(`${this.$t('planningPage.runUntil').toString()} : ${date}`)
        }

        periodicityString = `${periodicityNotUnique.join('<br />')}`
      }

      return periodicityString
    },

    plannedEmployeeList (): PlannedEmployee[] {
      return this.$store.getters[PLANNING_ASSISTANT_GET_PLANNED_EMPLOYEE_LIST]
    },

    shiftAvailability (): ShiftAvailability {
      return this.$store.getters[PLANNING_ASSISTANT_GET_SHIFT_AVAILABILITY]
    },

    isFixed (): boolean {
      if (this.editShift) {
        return (this.editShift.fixed === 'True')
      } else {
        return false
      }
    },

    isPeriodicity (): PlanningAssistantPeriodicityPayload {
      return this.$store.getters[PLANNING_ASSISTANT_GET_PERIODICITY]
    },

    isEdittingSerie (): boolean {
      return this.$store.getters[PLANNING_ASSISTANT_GET_IS_EDITTING_SERIE]
    },

    periodicityPlannedEmployeeList (): PeriodicityPlannedEmployee[] {
      return this.$store.getters[PLANNING_ASSISTANT_GET_PERIODICITY_PLANNED_EMPLOYEE_LIST]
    },

    selectedLanguage (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    },

    isEditingQcqShiftSerie (): boolean {
      if(this.editShift) {
        return !!(this.editShift && this.editShift.typeOfShift === 'QCQ Shift')
      } else {
        return true
      }
    }
  },

  methods: {
    formattedDate (date: string): string {
      return moment(date, 'DD.MM.YYYY').locale(this.selectedLanguage).format('DD.MM.YYYY - dddd')
    },

    onShiftAvailabilityChange (newVal: boolean): void {
      if (newVal) {
        this.$store.dispatch(PLANNING_ASSISTANT_SET_SHIFT_AVAILABILITY, ShiftAvailability.Fixed)
      } else {
        this.$store.dispatch(PLANNING_ASSISTANT_SET_SHIFT_AVAILABILITY, ShiftAvailability.Temporary)
      }
    },

    onCancelButtonClick (): void {
      this.$emit('cancelButtonClick')
    },

    onSaveButtonClick (): void {
      this.$emit('saveButtonClick')
    },
  },

  mounted (): void {
    if (this.editShift && this.editShift.fixed === 'True') {
      this.shiftAvailabilityState = true
    } else {
      this.shiftAvailabilityState = this.shiftAvailability !== ShiftAvailability.Temporary
    }
    const securityData = this.$store.getters[GET_SECURITY_DATA]
    const filteredData = securityData.filter((item: SecurityData) => item.area === 'planning')
    this.showAddressSelect = filteredData.find((item: SecurityData) => (item.component === 'selectbox-adress')).visibility
    this.showProjectSelect = filteredData.find((item: SecurityData) => (item.component === 'selectbox-project')).visibility
  }
})
